
// initial state
const state = {
  nav_title: '',
  nav_subtitle: '',
  nav_info: ''
}

// getters
const getters = {
  getNavTitle: state => state.nav_title,
  getNavSubtitle: state => state.nav_subtitle,
  getNavInfo: state => state.nav_info

}

// actions
const actions = {
  setNavTitle ({commit}, title) { commit('setNavTitleTo', title) },
  setNavSubtitle ({commit}, subtitle) { commit('setNavSubtitle', subtitle) },
  setNavInfo ({commit}, info) { commit('setNavInfo', info) }
}

// mutations
const mutations = {
  setNavTitleTo (state, title) {
    state.nav_title = title
  },
  setNavSubtitle (state, subtitle) {
    state.nav_subtitle = subtitle
  },
  setNavInfo (state, info) {
    state.nav_info = info
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/navigation.js